var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hist-graph"},[_c('h3',{staticStyle:{"text-align":"center","font-size":"1.2vw","padding":"0","color":"#F0EBE1"}},[_vm._v("按年代导航")]),_c('svg',{attrs:{"id":"histGraph","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }